(function () {
  var scheduled = false;
  var fitting = false;
  var branding = false;
  var TEAL = /#108474/gi;
  var TEAL_RGBA = /rgba\(\s*16\s*,\s*132\s*,\s*116/gi;

  function setBrandVars(target) {
    if (!target || !target.style || !target.style.setProperty) return;
    target.style.setProperty('--jdgm-primary-color', '#1a1a1a', 'important');
    target.style.setProperty('--jdgm-secondary-color', 'rgba(233, 163, 26, 0.14)', 'important');
    target.style.setProperty('--jdgm-star-color', '#e9a31a', 'important');
    target.style.setProperty('--jdgm-write-review-bg-color', '#e9a31a', 'important');
    target.style.setProperty('--jdgm-write-review-text-color', '#1a1a1a', 'important');
    target.style.setProperty('--jdgm-paginate-color', '#1a1a1a', 'important');
    target.style.setProperty('--jdgm-reviewer-name-color', '#1a1a1a', 'important');
    target.style.setProperty('--jm-review-widget-button-color', '#e9a31a', 'important');
    target.style.setProperty('--jm-review-widget-button-text-color', '#1a1a1a', 'important');
    target.style.setProperty('--jm-review-widget-star-and-histogram-color', '#e9a31a', 'important');
    target.style.setProperty('--jm-widget-primary-color', '#1a1a1a', 'important');
    target.style.setProperty('--jm-btn-bg', '#e9a31a', 'important');
    target.style.setProperty('--jm-btn-color', '#1a1a1a', 'important');
    target.style.setProperty('--jm-btn-border', '#e9a31a', 'important');
  }

  function patchSettingsStyle(style) {
    if (!style || !style.textContent) return;
    if (style.textContent.indexOf('108474') === -1 && style.textContent.indexOf('236C5B') === -1) return;
    style.textContent = style.textContent
      .replace(/--jdgm-primary-color:\s*#108474/gi, '--jdgm-primary-color: #1a1a1a')
      .replace(/--jdgm-paginate-color:\s*#108474/gi, '--jdgm-paginate-color: #1a1a1a')
      .replace(/--jdgm-reviewer-name-color:\s*#108474/gi, '--jdgm-reviewer-name-color: #1a1a1a')
      .replace(/--jdgm-write-review-bg-color:\s*#108474/gi, '--jdgm-write-review-bg-color: #e9a31a')
      .replace(/--jdgm-write-review-text-color:\s*white/gi, '--jdgm-write-review-text-color: #1a1a1a')
      .replace(/#236C5B/gi, '#e9a31a')
      .replace(TEAL, '#e9a31a')
      .replace(TEAL_RGBA, 'rgba(233, 163, 26');
  }

  function styleWriteButtons() {
    document.querySelectorAll(
      '.jdgm-write-rev-link, .jdgm-ask-question-btn, .jdgm-submit-rev, .jdgm-btn--solid, a[class*="write-rev"], button[class*="write-rev"], .jm-button--primary, [data-testid="write-review-button"]'
    ).forEach(function (button) {
      button.style.setProperty('background', '#e9a31a', 'important');
      button.style.setProperty('background-color', '#e9a31a', 'important');
      button.style.setProperty('color', '#1a1a1a', 'important');
      button.style.setProperty('border-color', '#e9a31a', 'important');
      button.style.setProperty('border-radius', '999px', 'important');
      button.style.setProperty('font-family', 'var(--base-font-family)', 'important');
      button.style.setProperty('font-weight', '700', 'important');
      button.style.setProperty('text-transform', 'none', 'important');
      button.style.setProperty('--jm-btn-bg', '#e9a31a', 'important');
      button.style.setProperty('--jm-btn-color', '#1a1a1a', 'important');
      button.style.setProperty('--jm-btn-border', '#e9a31a', 'important');
      button.style.setProperty('--jm-review-widget-button-color', '#e9a31a', 'important');
      button.style.setProperty('--jm-review-widget-button-text-color', '#1a1a1a', 'important');
    });
  }

  function patchReviewWidgetVars() {
    document.querySelectorAll('.jm-review-widget, [class*="jm-review-widget"]').forEach(function (widget) {
      setBrandVars(widget);
      if (widget.getAttribute('style') && /236C5B|108474/i.test(widget.getAttribute('style'))) {
        widget.setAttribute(
          'style',
          widget
            .getAttribute('style')
            .replace(/#236C5B/gi, '#e9a31a')
            .replace(/#108474/gi, '#1a1a1a')
            .replace(/--jm-review-widget-button-text-color:\s*#FFFFFF/gi, '--jm-review-widget-button-text-color: #1a1a1a')
        );
      }
    });
  }

  function applyBrand() {
    if (branding) return;
    branding = true;
    try {
      setBrandVars(document.documentElement);
      document.querySelectorAll('style.jdgm-settings-style').forEach(patchSettingsStyle);
      patchReviewWidgetVars();
      styleWriteButtons();
    } finally {
      branding = false;
    }
  }

  function cardsIn(container) {
    return Array.prototype.slice.call(container.querySelectorAll('.jdgm-card'));
  }

  function measure(card) {
    var previous = card.style.height;
    card.style.height = 'auto';
    card.style.minHeight = '0px';
    var height = card.scrollHeight;
    card.style.height = previous;
    return height;
  }

  function activeCard(cards) {
    return cards.filter(function (card) {
      return parseFloat(window.getComputedStyle(card).opacity) > 0.5;
    })[0] || cards[0];
  }

  function fit(widget) {
    if (widget.classList.contains('jdgm-cards-carousel')) return;

    var container = widget.querySelector('.jdgm-testimonials-container');
    if (!container) return;

    var cards = cardsIn(container);
    if (!cards.length) return;

    var bottomArrows = !!widget.querySelector('.jdgm-arrows--bottom');
    var heights = cards.map(measure);
    var height = 0;

    if (bottomArrows) {
      var active = activeCard(cards);
      height = heights[cards.indexOf(active)] || measure(active);
      if (!height) return;

      container.style.minHeight = '0px';
      container.style.height = height + 'px';
      container.style.overflow = 'hidden';
      cards.forEach(function (card, index) {
        card.style.height = heights[index] + 'px';
        card.style.minHeight = '0px';
      });
      return;
    }

    heights.forEach(function (value) {
      if (value > height) height = value;
    });

    if (!height) return;

    container.style.minHeight = height + 'px';
    container.style.height = height + 'px';
    cards.forEach(function (card) {
      card.style.height = height + 'px';
      card.style.minHeight = '0px';
    });
  }

  function fitAll() {
    if (fitting) return;
    fitting = true;
    try {
      document.querySelectorAll('.jdgm-testimonials-carousel').forEach(fit);
    } finally {
      fitting = false;
    }
  }

  function scheduleFit() {
    if (scheduled || fitting) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      fitAll();
    });
  }

  function start() {
    applyBrand();
    fitAll();

    var tries = 0;
    var timer = setInterval(function () {
      applyBrand();
      fitAll();
      tries += 1;
      if (tries >= 12) clearInterval(timer);
    }, 500);

    window.addEventListener('resize', scheduleFit);
    document.addEventListener('click', function (event) {
      if (!event.target.closest || !event.target.closest('.jdgm-arrow')) return;
      window.setTimeout(fitAll, 80);
      window.setTimeout(fitAll, 400);
    }, true);

    if (window.MutationObserver) {
      var brandObserver = new MutationObserver(function (mutations) {
        if (branding) return;
        var shouldBrand = mutations.some(function (mutation) {
          if (mutation.type !== 'childList') return false;
          var nodes = [];
          mutation.addedNodes.forEach(function (node) {
            nodes.push(node);
          });
          return nodes.some(function (node) {
            if (!node || node.nodeType !== 1) return false;
            var cls = node.className && node.className.toString ? node.className.toString() : '';
            return (
              cls.indexOf('jdgm-settings-style') !== -1 ||
              cls.indexOf('jdgm-write-rev') !== -1 ||
              cls.indexOf('jdgm-rev-widg') !== -1 ||
              cls.indexOf('jdgm-widget') !== -1 ||
              cls.indexOf('jm-review-widget') !== -1 ||
              cls.indexOf('jm-button') !== -1 ||
              (node.querySelector &&
                node.querySelector(
                  '.jdgm-write-rev-link, .jdgm-rev-widg, .jm-review-widget, .jm-button--primary, [data-testid="write-review-button"], style.jdgm-settings-style'
                ))
            );
          });
        });
        if (shouldBrand) applyBrand();
      });
      brandObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });

      document.querySelectorAll('.jdgm-testimonials-carousel').forEach(function (widget) {
        var observer = new MutationObserver(function (mutations) {
          if (fitting) return;

          var shouldFit = mutations.some(function (mutation) {
            if (mutation.type === 'childList') return true;
            if (mutation.type !== 'attributes') return false;
            var target = mutation.target;
            if (!target || !target.classList) return false;
            return target.classList.contains('jdgm-card') || target.classList.contains('jdgm-carousel-item');
          });

          if (shouldFit) scheduleFit();
        });

        observer.observe(widget, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'aria-hidden']
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('load', function () {
    applyBrand();
    fitAll();
  });
})();
